import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./tracking";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // Track page view on route change
    trackPageView(location.pathname, document.title);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
